




export default function Products({ history }, props) {
    return (



        <div className="flex flex-col w-full items-center justify-start space-y-[32px] px-[24px] xl:px-[200px] py-[40px] text-[14px] leading-[20px]">
            <div className="flex flex-col xl:flex-row xl:w-[1100px]  w-full  items-start justify-start  xl:space-x-[34px]   ">


                <div className="flex justify-center w-[100%] xl:hidden "  >
                    <img src={'/assets/img/robot/robots-03.png'} width="300px" />

                </div>

                <div className="hidden  justify-center xl:block xl:w-[300px] "  >
                    <img src={'/assets/img/robot/robots-03.png'} width="300px" />

                </div>
                <div className="flex text-justify items-center px-[25px] pt-[20px] xl:pt-[0px] xl:w-[calc(100%-300px)] xl:pr-[20px] xl:h-[300px]">
                    23rd Studio is an innovative development company dedicated to creating software, platforms, and products that leverage artificial intelligence, machine learning, and data science. Founded by a Ph.D. alumnus of the Royal Institute of Technology (KTH), the company boasts extensive research experience in various research laboratories across Sweden, including Scilifelab (KTH), Stockholm University (SU), and KI. Consequently, the company’s projects and
                     products span diverse fields of data science. Notably, the primary focus of the company’s products
                      lies in encapsulating intricate AI challenges within user-friendly platforms characterized by intuitive UX and design.              
                        </div>


            </div>

            <div className="flex flex-col space-y-[50px]  px-[24px]   xl:w-[1100px]">
                {/* <div className="flex w-full   items-center justify-center  ">
                    <span className="text-[25px]">

                        <img src={'/assets/img/logo-motion-0205_1.gif'} width="200px" />

                    </span>
                </div> */}

                {/* spice */}
                <div className="flex  flex-col xl:flex-row  float-left xl:space-x-[50px] xl:space-y-0  space-y-[15px]  ">

                    <div className="flex flex-col float-left w-[100%] xl:w-[calc(100%-400px)]  text-justify">
                        <span className="font-bold">Spice Up Your Stream</span>
                        <span className="text-[14px] leading-[20px]">
                            Spice.Stream is an artificial intelligence platform designed to enhance live internet streams,
                            such as those on platforms like Twitch and YouTube. The platform utilizes sophisticated machine learning
                            and real-time video analytics to enable graphical stream widgets that are cognizant of and responsive to the
                            content of the stream. The primary objective of Spice.Stream is to redirect the interaction of the audience (chat)
                            toward the current events transpiring within the stream, potentially enabling the audience to influence the stream in real-time.
                            This platform is currently in alpha testing stage.</span>

                    </div>

                    <div className="flex w-[100%] xl:w-[400px] justify-center items-center ">
                        <div className="w-[100%] h-[250px] rounded-xl overflow-hidden shadow-md">
                            <iframe
                                className="w-full h-full"
                                src="https://www.youtube.com/embed/x1UxB4-wjYs"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            >

                            </iframe>
                        </div>
                    </div>





                </div>

                {/* Neural Refinery */}

                <div className="flex  flex-col xl:flex-row  float-left xl:space-x-[50px] xl:space-y-0  space-y-[15px]  ">

                    <div className="flex flex-col float-left w-[100%] xl:w-[calc(100%-400px)]  text-justify">
                        <span className="font-bold">Neural Refinery</span>
                        <span>
                            Neural Refinery is a patent-pending video analytics platform that enables the no-code creation of intricate video analytics pipelines.
                            This platform significantly contributes to our ability to effortlessly augment our products with video analytics solutions.
                            The company is actively engaged in the development of a comparable solution for bioinformatics pipelines.
                        </span>
                    </div>
                    <div className="flex w-[100%] xl:w-[400px] justify-center items-center ">
                        <div className="w-[100%] h-[250px] rounded-xl overflow-hidden shadow-md">
                            <iframe
                                className="w-full h-full"
                                src="https://www.youtube.com/watch?v=jgsBS5tNxuY"
                                title="YouTube video player"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>

                </div>


                {/* ETD */}

                <div className="flex  flex-col xl:flex-row  float-left xl:space-x-[50px] xl:space-y-0  space-y-[15px]  ">

                    <div className="flex flex-col float-left w-[100%] xl:w-[calc(100%-400px)]  text-justify">
                       <span className="font-bold">ETD</span>
                        <span>
                            ETD is a collaborative platform established between the 23rd Studio and the Freiburg University
                            Clinic for the collection, organization, and analysis of biological data derived from clinical trials.
                            The platform is currently undergoing beta testing within a clinical trial for inflammatory
                            skin diseases conducted at the Freiburg University Clinic. </span>
                    </div>
                    <div className="flex w-[100%] xl:w-[400px] justify-center items-center ">
                        <div className="w-[100%] h-[250px] rounded-xl overflow-hidden shadow-md">
                        
                        </div> 
                    </div>

                </div>

            </div>


        </div>




    )
}

